<template>
    <div class="container">
        <div class="sweep">
            <div class="form-wrapper">
                <el-form
                    ref="loginForm"
                    class="login-form"
                    auto-complete="on"
                    label-position="left"
                >
                    <!-- 登录标题（新增，提升视觉层次） -->
                    <div class="login-title">优优洗车管理系统</div>

                    <el-form-item prop="username">
                        <div class="input-wrapper">
                            <el-input
                                v-model.trim="loginParams.username"
                                name="username"
                                type="text"
                                auto-complete="on"
                                placeholder="账号"
                                size="large"
                            />
                        </div>
                    </el-form-item>

                    <el-form-item prop="password">
                        <div class="input-wrapper">
                            <el-input
                                type="password"
                                v-model.trim="loginParams.password"
                                name="password"
                                auto-complete="on"
                                placeholder="密码"
                                @keyup.enter="handleLogin"
                                size="large"
                            />
                        </div>
                    </el-form-item>

                    <el-form-item>
                        <div class="button-wrapper">
                            <el-button
                                :loading="loginParams.showLoading"
                                type="primary"
                                size="large"
                                @click="handleLogin"
                            >
                                登录
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { apiLogin } from "@/api/requestApis.js";
import { useRouter } from "vue-router";
import { reactive, onMounted, onBeforeUnmount } from "vue";
import { ElMessage } from "element-plus";

export default {
    setup() {
        const router = useRouter();
        const loginParams = reactive({
            showLoading: false,
            username: "",
            password: "",
        });

        // 处理登录逻辑
        const handleLogin = async () => {
            if (loginParams.username && loginParams.password) {
                loginParams.showLoading = true;
                try {
                    const userInfo = await apiLogin({
                        userName: loginParams.username,
                        password: loginParams.password,
                    });

                    if (userInfo) {
                        localStorage.setItem(
                            "userInfo",
                            JSON.stringify({
                                userName: userInfo.userName,
                                userId: userInfo.userId,
                            })
                        );
                        localStorage.setItem("token", userInfo.token);
                        router.push({ name: "home" });
                    } else {
                        ElMessage.error("登录失败，请检查账号密码");
                    }
                } catch (error) {
                    console.error("登录请求失败：", error);
                    ElMessage.error("登录出错，请稍后重试");
                } finally {
                    loginParams.showLoading = false;
                }
            } else {
                ElMessage.error("请输入账号和密码");
            }
        };

        return {
            handleLogin,
            loginParams,
        };
    },
};
</script>

<style scoped>
/* 基础容器样式 - 适配移动端 */
.container {
    width: 100vw;
    height: 100vh;
    background-color: #2d3a4b;
    background-image: url("../../assets/loginBG.jpeg");
    background-repeat: no-repeat;
    background-size: cover; /* 改为cover，防止变形 */
    background-position: center center; /* 居中显示 */
    overflow: hidden;
    position: relative;
}

/* 登录框容器 - 响应式调整 */
.sweep {
    width: 400px;
    max-width: 90%; /* 移动端最大宽度90% */
    height: auto; /* 高度自适应 */
    min-height: 300px; /* 最小高度 */
    background: rgba(255, 255, 255, 0.95); /* 半透明背景，提升可读性 */
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(-25%, -50%);
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15); /* 增加阴影，提升层次感 */
    padding: 20px 0; /* 内边距 */
    box-sizing: border-box;
}

/* 表单外层容器 */
.form-wrapper {
    width: 80%;
    margin: 0 auto;
    padding: 10px 0;
}

/* 登录标题 */
.login-title {
    font-size: 20px;
    font-weight: 600;
    color: #2d3a4b;
    text-align: center;
    margin-bottom: 30px;
}

/* 输入框容器 */
.input-wrapper {
    width: 100%;
    margin-bottom: 10px;
}

/* 按钮容器 */
.button-wrapper {
    width: 100%;
    margin-top: 15px;
}

/* 登录表单样式优化 */
.login-form {
    width: 100%;
}

/* ========== 移动端适配 (768px以下) ========== */
@media screen and (max-width: 767px) {
    /* 登录框位置调整：居中显示，不再靠右 */
    .sweep {
        right: 50%;
        transform: translate(50%, -50%);
        width: 85%;
        padding: 15px 0;
    }

    /* 表单容器宽度调整 */
    .form-wrapper {
        width: 85%;
    }

    /* 登录标题字体调整 */
    .login-title {
        font-size: 18px;
        margin-bottom: 25px;
    }

    /* 输入框和按钮间距调整 */
    .input-wrapper {
        margin-bottom: 8px;
    }

    .button-wrapper {
        margin-top: 10px;
    }

    /* 背景图适配：移动端优化 */
    .container {
        background-size: cover;
        background-attachment: fixed; /* 固定背景，防止滚动 */
    }
}

/* ========== 小屏手机适配 (480px以下) ========== */
@media screen and (max-width: 479px) {
    .sweep {
        width: 90%;
        min-height: 280px;
    }

    .form-wrapper {
        width: 90%;
    }

    .login-title {
        font-size: 16px;
        margin-bottom: 20px;
    }

    /* 进一步优化内边距 */
    .sweep {
        padding: 10px 0;
    }
}

/* ========== 横屏手机适配 ========== */
@media screen and (max-height: 500px) and (orientation: landscape) {
    .sweep {
        height: auto;
        min-height: auto;
        padding: 10px 0;
        top: 50%;
        transform: translate(50%, -50%);
    }

    .login-title {
        margin-bottom: 15px;
    }

    .form-wrapper {
        width: 80%;
    }
}

/* ========== 通用优化 ========== */
/* 输入框聚焦样式优化 */
::v-deep .el-input__wrapper {
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
}

::v-deep .el-input__wrapper:focus-within {
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
    border-color: #409eff !important;
}

/* 按钮样式优化 */
::v-deep .el-button--primary {
    border-radius: 8px;
    height: 44px; /* 增大触控区域 */
    font-size: 16px;
    width: 100%;
}

/* 加载状态优化 */
::v-deep .el-button--loading .el-icon-loading {
    margin-right: 8px;
}

/* 禁止选中文本 */
.container, .sweep {
    user-select: none;
    -webkit-user-select: none;
}

/* 触控优化 */
.el-input, .el-button {
    touch-action: manipulation; /* 优化移动端触控 */
}
</style>
